export default "__VITE_ASSET__uT4nsvnb__"